import { Navigate, Route, Routes } from "react-router-dom";
import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import SideNavigationBar from "../../components/sideNavigationBar/SideNavigationBar";
import AddProduct from "../../views/setup/products/product/AddProduct";
import AssemblyItems from "../../views/setup/assemblyItems/AssemblyItems";
import Brands from "../../views/setup/brands/Brands";
import Locations from "../../views/setup/locations/Locations";
import LocationDetails from "../../views/setup/locations/LocationDetails";
import CertifiedByOptions from "../../views/setup/certifiedByOptions/CertifiedByOptions";
import Customers from "../../views/setup/customers/Customers";
import PriceRules from "../../views/setup/priceRules/PriceRules";
import {
  EntityAuditPage,
  EntityTypeAuditPage,
} from "../../views/audit/AuditPage";
import Dashboard from "../../views/dashboard/Dashboard";
import Manufacturers from "../../views/setup/manufacturers/Manufacturers";
import Preservatives from "../../views/setup/preservatives/Preservatives";
import ProductScreen from "../../views/setup/products/product/ProductScreen";
import Products from "../../views/setup/products/Products";
import MyIngredients from "../../views/setup/myIngredients/MyIngredients";
import Allergens from "../../views/setup/allergens/Allergens";
import Claims from "../../views/setup/claims/Claims";
import ProductionCosts from "../../views/setup/productionCosts/ProductionCosts";
import ProductTypes from "../../views/setup/productTypes/ProductTypes";
import UnitOfMeasures from "../../views/setup/unitOfMeasures/UnitOfMeasures";
import TaxRates from "../../views/setup/taxRates/TaxRates";
import Recipes from "../../views/recipes/Recipes";
import CreateRecipe from "../../views/recipes/CreateRecipe";

import Users from "../../views/users/Users";

import ReceivingInvoiceIndex from "../../views/receiving/invoices/ReceivingInvoiceIndex";
import AllReceivingInvoices from "../../views/receiving/invoices/AllReceivingInvoices";
import AddReceivingInvoice from "../../views/receiving/invoices/AddReceivingInvoice";
import PurchaseOrders from "../../views/purchaseOrders/PurchaseOrders";
import CreatePurchaseOrder from "../../views/purchaseOrders/CreatePurchaseOrder";

import NewPackageScreen from "../../views/packaging/NewPackageScreen";
import PackagingRecords from "../../views/packaging/PackagingRecords";

import { useEffect, useRef, useState } from "react";

import { classNames, withRouter } from "../../shared/utility";
import MyAccount from "../../views/myAccount/MyAccount";
import CompanySettings from "../../views/companySettings/CompanySettings";

import ManufactureNewProduct from "../../views/production/ManufactureNewProduct";
import ManufacturedProducts from "../../views/production/ManufacturedProducts";
import ReceivingInvoiceDetails from "../../views/receiving/invoices/details/ReceivingInvoiceDetails";
import CostCalcution from "../../views/costCalculation/CostCalculation";
import ManufacturedProductDetails from "../../views/production/ManufacturedProductDetails";
import QaReportsScreen from "../../views/qaReports/QaReportsScreen";
import RecipeDetails from "../../views/recipes/RecipeDetails";
import InventoryRawMaterialScreen from "../../views/inventory/rawMaterial/InventoryRawMaterialScreen";
import InventoryManufacturedMaterialScreen from "../../views/inventory/manufacturedMaterial/InventoryManufacturedMaterialScreen";
import PalletLetDownScreen from "../../views/inventory/palletLetDown/PalletLetDownScreen";
import ManageOrders from "../../views/orders/ManageOrders";
import CreateOrder from "../../views/orders/CreateOrder";
import OrderDetails from "../../views/orders/OrderDetails";
import ManageShippings from "../../views/shipping/ManageShippings";
import ShippingDetails from "../../views/shipping/ShippingDetails";
import CreditReturns from "../../views/shipping/CreditReturns";
import CreditReturnDetails from "../../views/shipping/CreditReturnDetails";
import HeaderLayout from "./HeaderLayout";
import TraceabilityIndex from "../../views/traceability/TraceabilityIndex";
import TraceabilityManufactured from "../../views/traceability/TraceabilityManufactured";
import TraceabilityPackagingBarcode from "../../views/traceability/TraceabilityPackagingBarcode";
import TraceabilityReceivingItemLookup from "../../views/traceability/TraceabilityReceivingItemLookup";
import TraceabilitySupplier from "../../views/traceability/TraceabilitySupplier";
import CostcoSkus from "../../views/orders/CostcoSkus";
import MediaManager from "../../views/mediaManager/MediaManager";
import QuickbooksLogin from "../../views/quickbooks/QuickbooksLogin";
import { Toast } from "primereact/toast";
import QuickbooksCallbackScreen from "../../views/quickbooks/QuickbooksCallbackScreen";
import BarcodeScanner from "../../views/setup/barcodeScanner/BarcodeScanner";
import ManufacturedProductsEmployee from "../../views/production/ManufacturedProductsEmployee";
import InProcessMonitoringStatuses from "../../views/setup/processStatus/InProcessMonitoringStatuses";
import InProcessMonitoringHistory from "../../views/inProcessMonitoring/InProcessMonitoringHistory";
import ProductionCalendar from "../../views/calendar/ProductionCalendar";
import OrdersCalendar from "../../views/calendar/OrdersCalendar";
import Laboratories from "../../views/setup/laboratories/Laboratories";
import Equipments from "../../views/setup/equipments/Equipments";
import VisitorTypes from "../../views/setup/visitorTypes/VisitorTypes";
import LabSamples from "../../views/labSamples/LabSamples";
import LabSampleFormView from "../../views/labSamples/LabSampleFormView";
import EquipmentMaintenance from "../../views/equipmentMaintenance/EquipmentMaintenance";
import EquipmentMaintenanceForm from "../../views/equipmentMaintenance/EquipmentMaintenanceForm";
import Visitors from "../../views/visitorsLog/Visitors";
import VisitorLog from "../../views/visitorsLog/VisitorLog";

import { applyTenantBranding } from "../../shared/tenantBranding";

function DefaultLayout(props) {
  const {
    logout,
    user_type,
    tenant,
    snackbarQueue,
    removeSnackbar,
    permissions,
    roles,
  } = props;
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const size = useWindowSize();
  const toast = useRef(null);

  useEffect(() => {
    applyTenantBranding(tenant);
  }, [tenant]);

  useEffect(() => {
    snackbarQueue.forEach((snackbar) => {
      toast.current.show({
        severity: snackbar.type,
        summary: snackbar.message,
        content: null,
        life: 3000,
      });
      removeSnackbar(snackbar.id);
    });
  }, [snackbarQueue]);

  useEffect(() => {
    if (size.width < 991) {
      setSidebarOpen(false);
    } else {
      setSidebarOpen(true);
    }
  }, [size]);

  const outsideClickRef = useRef(null);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (
        outsideClickRef.current &&
        !outsideClickRef.current.contains(event.target) &&
        size.width < 991
      ) {
        setSidebarOpen(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [outsideClickRef, size]);

  return (
    <div
      className={classNames(
        sidebarOpen
          ? size.width < 991
            ? "scroll-blocked layout-mobile-active"
            : ""
          : "layout-static-inactive",
        "layout-container layout-static layout-light",
      )}
    >
      <SideNavigationBar
        user_type={user_type}
        tenant={tenant}
        outsideClickRef={outsideClickRef}
        onNavigate={() => {
          if (size.width < 991) setSidebarOpen(false);
        }}
      />
      <Toast ref={toast} />
      <div className="layout-content-wrapper">
        <div className="layout-mask"></div>
        {tenant === null ? (
          <div className="border-b border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-900">
            Your account is not assigned to a company yet.
          </div>
        ) : null}
        <HeaderLayout
          sidebarOpen={sidebarOpen}
          logout={logout}
          setSidebarOpen={setSidebarOpen}
          user_type={user_type}
          permissions={permissions}
          roles={roles}
        />
        {parseInt(user_type) === 2 ? (
          <Routes>
            <Route path="/my-account" element={<MyAccount />} />
            <Route
              path="/account/company-settings"
              element={<CompanySettings />}
            />
            <Route path="*" element={<Navigate to="/export-label" replace />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/dashboard" element={<Dashboard logout={logout} />} />

            <Route path="/my-account" element={<MyAccount />} />
            <Route
              path="/account/company-settings"
              element={<CompanySettings />}
            />

            <Route path="/supplier-items" element={<AssemblyItems />} />

            <Route path="/brands" element={<Brands />} />
            <Route path="/locations" element={<Locations />} />
            <Route
              path="/locations/:locationId"
              element={<LocationDetails />}
            />

            <Route path="/customers" element={<Customers />} />
            <Route path="/price-rules" element={<PriceRules />} />
            <Route
              path="/audit-histories/:entityType"
              element={<EntityTypeAuditPage />}
            />
            <Route
              path="/audit/:entityType/:entityId"
              element={<EntityAuditPage />}
            />

            <Route
              path="/certification-types"
              element={<CertifiedByOptions />}
            />

            <Route path="/cost-calculation" element={<CostCalcution />} />

            <Route path="/suppliers" element={<Manufacturers />} />

            <Route path="/product-allergens" element={<Allergens />} />
            <Route path="/product-claims" element={<Claims />} />
            <Route path="/product-types" element={<ProductTypes />} />
            <Route path="/production-costs" element={<ProductionCosts />} />
            <Route path="/bom-items" element={<MyIngredients />} />
            <Route path="/my-products" element={<Products />} />
            <Route path="/my-products/new" element={<AddProduct />} />
            <Route path="/my-products/:productId" element={<ProductScreen />} />
            <Route path="/preservatives" element={<Preservatives />} />
            <Route
              path="/manufactured-products-employee"
              element={<ManufacturedProductsEmployee />}
            />

            <Route path="/purchase-orders" element={<PurchaseOrders />} />
            <Route
              path="/purchase-orders/new"
              element={<CreatePurchaseOrder />}
            />
            <Route
              path="/purchase-orders/:purchaseOrderId/receive"
              element={<AddReceivingInvoice />}
            />
            <Route
              path="/purchase-orders/:purchaseOrderId"
              element={<CreatePurchaseOrder />}
            />

            <Route
              path="/receiving-index"
              element={<ReceivingInvoiceIndex />}
            />
            <Route
              path="/receiving-invoices"
              element={<AllReceivingInvoices />}
            />
            <Route path="/quickbooks-login" element={<QuickbooksLogin />} />
            <Route
              path="/receiving-invoices/new"
              element={<AddReceivingInvoice />}
            />
            <Route
              path="/receiving-invoices/:invoiceId"
              element={<ReceivingInvoiceDetails />}
            />

            <Route
              path="/manufacture-product"
              element={<ManufactureNewProduct />}
            />
            <Route
              path="/manufactured-products"
              element={<ManufacturedProducts />}
            />
            <Route
              path="/manufactured-products/:productId"
              element={<ManufacturedProductDetails />}
            />
            <Route
              path="/calendar/production"
              element={<ProductionCalendar />}
            />

            <Route path="/packaging-reports" element={<PackagingRecords />} />
            <Route path="/packaging-new" element={<NewPackageScreen />} />

            <Route path="/unit-of-measures" element={<UnitOfMeasures />} />
            <Route path="/tax-rates" element={<TaxRates />} />
            <Route path="/barcode-scanner" element={<BarcodeScanner />} />

            <Route path="/qa-reports" element={<QaReportsScreen />} />
            <Route path="/media-manager" element={<MediaManager />} />
            <Route path="/laboratories" element={<Laboratories />} />
            <Route path="/equipments" element={<Equipments />} />
            <Route path="/visitor-types" element={<VisitorTypes />} />

            <Route path="/lab-samples" element={<LabSamples />} />
            <Route path="/lab-samples/new" element={<LabSampleFormView />} />
            <Route path="/lab-samples/:id" element={<LabSampleFormView />} />

            <Route
              path="/equipment-maintenance"
              element={<EquipmentMaintenance />}
            />
            <Route
              path="/equipment-maintenance/new"
              element={<EquipmentMaintenanceForm />}
            />
            <Route
              path="/equipment-maintenance/:id"
              element={<EquipmentMaintenanceForm />}
            />

            <Route path="/visitors" element={<Visitors />} />
            <Route path="/visitors/new" element={<VisitorLog />} />
            <Route path="/visitors/:id" element={<VisitorLog />} />

            <Route
              path="/process-statuses"
              element={<InProcessMonitoringStatuses />}
            />
            <Route
              path="/in-process-monitoring"
              element={<InProcessMonitoringHistory />}
            />

            <Route path="/recipes" element={<Recipes />} />
            <Route path="/recipes/:recipeId" element={<RecipeDetails />} />
            <Route path="/create-recipe" element={<CreateRecipe />} />

            <Route
              path="/quickbooks/callback"
              element={<QuickbooksCallbackScreen />}
            />

            <Route
              path="/inventory-raw-material"
              element={<InventoryRawMaterialScreen />}
            />
            <Route
              path="/inventory-manufactured-material"
              element={<InventoryManufacturedMaterialScreen />}
            />
            <Route path="/pallet-let-down" element={<PalletLetDownScreen />} />

            <Route path="/orders" element={<ManageOrders />} />
            <Route path="/orders/:orderId" element={<OrderDetails />} />
            <Route path="/create-order" element={<CreateOrder />} />
            <Route path="/calendar/orders" element={<OrdersCalendar />} />
            <Route path="/import-skus" element={<CostcoSkus />} />

            <Route path="/shippings" element={<ManageShippings />} />
            <Route
              path="/shippings/:shippingId"
              element={<ShippingDetails />}
            />
            <Route path="/credit-returns" element={<CreditReturns />} />
            <Route
              path="/credit-returns/:creditReturnId"
              element={<CreditReturnDetails />}
            />

            <Route path="/traceability" element={<TraceabilityIndex />} />
            <Route
              path="/traceability/manufactured"
              element={<TraceabilityManufactured />}
            />
            <Route
              path="/traceability/supplier"
              element={<TraceabilitySupplier />}
            />
            <Route
              path="/traceability/packaging-barcode"
              element={<TraceabilityPackagingBarcode />}
            />
            <Route
              path="/traceability/receiving-item"
              element={<TraceabilityReceivingItemLookup />}
            />

            <Route path="/users" element={<Users />} />

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user_type: state.auth.user_type,
    tenant: state.auth.tenant,
    permissions: state.auth.permissions,
    roles: state.auth.roles,
    snackbarQueue: state.utilities.snackbarQueue,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    removeSnackbar: (snackbarId) =>
      dispatch(actions.removeSnackbar(snackbarId)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DefaultLayout),
);

function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}
